export * from './product-details'
